// http://sampsonblog.com/749/simple-throttle-function
/**
 * Throttling function to rate limit any continous event calls.
 * @param  {Function} callback [description]
 * @param  {[type]}   limit    [description]
 * @return {[type]}            [description]
 */
export default function throttle(callback, limit) {
  let wait = false; // Initially, we're not waiting
  return function() { // We return a throttled function
    if (!wait) { // If we're not waiting
      callback.call(); // Execute users function
      wait = true; // Prevent future invocations
      setTimeout(function() { // After a period of time
        wait = false; // And allow future invocations
      }, limit);
    }
  };
};
